export default {
      id: "years-99-usage",
      viewBox: "0 0 200 60",
      url: __webpack_public_path__ + "sprite.svg#years-99",
      toString: function () {
        return this.url;
      }
    }